export enum MutationTypes {
  UPDATE_STREAMER = 'UPDATE_STREAMER',
  UPDATE_ROLE = 'UPDATE_ROLE',
  SET_DEBUG = 'SET_DEBUG',
  SET_EXTENDED_ROLE = 'SET_EXTENDED_ROLE',
}
